import styled from 'styled-components';

export const CycleChangeMLStyled = styled.div`
  .checked {
    color: #1565c0;
  }
  .unchecked {
    color: #616161;
  }
`;
